<form [formGroup]="customerSearchForm">
  <div class="searchBox input-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      />
    </svg>
    <input
      #searchBox
      [ngClass]="{ expanded: show }"
      [autofocus]="!disabled"
      type="text"
      [placeholder]="placeHolder"
      formControlName="customerSearch"
      class="form-control"
      (focus)="isFocus($event)"
      (blur)="lostFocus($event)"
      (keyup)="onKeyboard($event)"
    />
    <span class="loading-spinner" *ngIf="loading$ | async">
      <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
    </span>
  </div>
  <div>
    <div #searchResult *ngIf="show" [ngClass]="forOrderHeader ? 'forOrderHeaderResult' : 'searchResult'">
      <table *ngIf="listOfCustomers.length > 0" class="border table table-striped shadow-lg w-100">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase">
              <label>Customer Name</label>
            </th>
            <th scope="col" class="text-uppercase">
              <label>Customer Type</label>
            </th>
            <th scope="col" class="text-uppercase text-nowrap">
              <label>Revenue Branch</label>
            </th>
            <th scope="col" class="text-uppercase"><label>Phone</label></th>
            <th scope="col" class="text-uppercase"><label>Email</label></th>
            <th scope="col" class="text-uppercase"><label>Address</label></th>
            <th scope="col" class="text-uppercase text-nowrap">
              <label>Vehicle Rego</label>
            </th>
            <th scope="col" class="text-uppercase text-nowrap">
              <label>Customer Number</label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            (click)="selectCustomer(customer)"
            *ngFor="let customer of customers$ | async; let i = index"
            [ngClass]="i === indexFocus ? 'table-primary' : ''"
          >
            <td>
              <mat-icon class="selectIcon" *ngIf="i === indexFocus"> keyboard_arrow_right</mat-icon>
              <ngb-highlight [result]="customer.customerName" [term]="customerSearchForm.get('customerSearch').value"> </ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.customerType" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.revenueBranchName" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.phone" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.email" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="getLocation(customer)" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.vehicleRego" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="customer.customerNumber" [term]="customerSearchForm.get('customerSearch').value"></ngb-highlight>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="text-danger text-center" *ngIf="hasMoreRecords && show">
        More results exist - Please narrow search
        <div #customerType>
          <input type="radio" value="" formControlName="customerSearchType" /><span class="px-1"></span><label>ALL</label>
          <span class="px-2"></span>
          <input type="radio" value="RETAIL" formControlName="customerSearchType" /><span class="px-1"></span><label>RETAIL</label>
          <span class="px-2"></span>
          <input type="radio" value="BILLTO" formControlName="customerSearchType" /><span class="px-1"></span><label>BILL TO</label>
          <span class="px-2"></span>
          <input type="radio" value="SHIPTO" formControlName="customerSearchType" /><span class="px-1"></span><label>SHIPTO</label>
        </div>
      </div>
    </div>
  </div>
</form>
